// Analytics Actions
import { UI_EVENT_TYPE } from "./types/AnalyticsEventType";

// Event Container

export const makeEventContainer = v => v;
export const EVENT_CONTAINER_CLOUD_FORTIFIED_INFO_MODAL = makeEventContainer('cloudFortifiedInfoModal');
export const EVENT_CONTAINER_CLOUD_FORTIFIED_TOOLTIP = makeEventContainer('cloudFortifiedTooltip');
export const EVENT_CONTAINER_CERTIFICATION_SECTION = makeEventContainer('certificationSection');

// Analytics Actions

export const makeAnalyticsAction = v => v;
export const ANALYTICS_ACTION_CLICKED = makeAnalyticsAction('clicked');
export const ANALYTICS_ACTION_COLLAPSED = makeAnalyticsAction('collapsed');
export const ANALYTICS_ACTION_EXPANDED = makeAnalyticsAction('expanded');
export const ANALYTICS_ACTION_FETCH_FAILED = makeAnalyticsAction('fetchFailed');
export const ANALYTICS_ACTION_REMOVED = makeAnalyticsAction('removed');
export const ANALYTICS_ACTION_REMOVE_FAILED = makeAnalyticsAction('removeFailed');
export const ANALYTICS_ACTION_RENDERED = makeAnalyticsAction('rendered');
export const ANALYTICS_ACTION_SUBMITTED = makeAnalyticsAction('submitted');
export const ANALYTICS_ACTION_CHANGED = makeAnalyticsAction('changed');
export const ANALYTICS_ACTION_TOGGLED = makeAnalyticsAction('toggled');
export const ANALYTICS_ACTION_BLURRED = makeAnalyticsAction('blurred');
export const ANALYTICS_ACTION_VIEWED = makeAnalyticsAction('viewed');

// Analytics Action Subjects

export const makeAnalyticsActionSubject = v => v;
export const ANALYTICS_SUBJECT_FORM_FIELD = makeAnalyticsActionSubject('formField');
export const ANALYTICS_SUBJECT_APP = makeAnalyticsActionSubject('app');
export const ANALYTICS_SUBJECT_BREADCRUMB = makeAnalyticsActionSubject('breadcrumb');
export const ANALYTICS_SUBJECT_BUTTON = makeAnalyticsActionSubject('button');
export const ANALYTICS_SUBJECT_LINK = makeAnalyticsActionSubject('link');
export const ANALYTICS_SUBJECT_MENU = makeAnalyticsActionSubject('menu');
export const ANALYTICS_SUBJECT_MENU_ITEM = makeAnalyticsActionSubject('menuItem');
export const ANALYTICS_SUBJECT_TAB = makeAnalyticsActionSubject('tab');
export const ANALYTICS_SUBJECT_LOZENGE = makeAnalyticsActionSubject('lozenge');
export const ANALYTICS_SUBJECT_TILE = makeAnalyticsActionSubject('tile');
export const ANALYTICS_SUBJECT_TILES = makeAnalyticsActionSubject('tiles');
export const ANALYTICS_SUBJECT_UI = makeAnalyticsActionSubject('ui');
export const ANALYTICS_SUBJECT_SEARCH = makeAnalyticsActionSubject('search');
export const ANALYTICS_SUBJECT_FILTER = makeAnalyticsActionSubject('filter');
export const ANALYTICS_SUBJECT_RADIO = makeAnalyticsAction('radioButton');
export const ANALYTICS_SUBJECT_TEXT_FIELD = makeAnalyticsActionSubject('textField');
export const ANALYTICS_SUBJECT_NOT_FOUND = makeAnalyticsActionSubject('pageNotFound');
export const ANALYTICS_SUBJECT_MODAL = makeAnalyticsActionSubject('modal');
export const ANALYTICS_SUBJECT_ROW_ITEM = makeAnalyticsActionSubject('rowItem');
export const ANALYTICS_SUBJECT_CHECKBOX = makeAnalyticsActionSubject('checkbox');
export const ANALYTICS_SUBJECT_BANNER = makeAnalyticsActionSubject('banner');
export const ANALYTICS_SUBJECT_TOOLTIP = makeAnalyticsActionSubject('tooltip');

// Analytics Category Names

export const makeAnalyticsCategory = v => v;
export const ButtonClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_BUTTON,
  details: 'User clicked a button',
  type: UI_EVENT_TYPE
};
export const LinkClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_LINK,
  details: 'User clicked a link',
  type: UI_EVENT_TYPE
};
export const TextFieldBlurEvent = {
  action: ANALYTICS_ACTION_BLURRED,
  actionSubject: ANALYTICS_SUBJECT_TEXT_FIELD,
  details: 'User clicked away from the text field',
  type: UI_EVENT_TYPE
};
export const RadioButtonToggledEvent = {
  action: ANALYTICS_ACTION_TOGGLED,
  actionSubject: ANALYTICS_SUBJECT_RADIO,
  details: 'User toggled a radio option',
  type: UI_EVENT_TYPE
};
export const TileClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_TILE,
  details: 'User clicked a tile',
  type: UI_EVENT_TYPE
};
export const MenuExpandedEvent = {
  action: ANALYTICS_ACTION_EXPANDED,
  actionSubject: ANALYTICS_SUBJECT_MENU,
  details: 'User expanded a menu',
  type: UI_EVENT_TYPE
};
export const MenuItemClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_MENU_ITEM,
  details: 'User clicked a menu item',
  type: UI_EVENT_TYPE
};
export const BreadcrumbClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_BREADCRUMB,
  details: 'User clicked a breadcrumb item',
  type: UI_EVENT_TYPE
};
export const SearchSubmittedEvent = {
  action: ANALYTICS_ACTION_SUBMITTED,
  actionSubject: ANALYTICS_SUBJECT_SEARCH,
  details: 'When a search input is submitted',
  type: UI_EVENT_TYPE
};
export const FilterClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_FILTER,
  details: 'User has selected a filter for the app search',
  type: UI_EVENT_TYPE
};
export const TabClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_TAB,
  details: 'User clicked a tab',
  type: UI_EVENT_TYPE
};
export const LozengeClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_LOZENGE,
  details: 'User clicked a lozenge',
  type: UI_EVENT_TYPE
};
export const PageNotFoundEvent = {
  action: ANALYTICS_ACTION_RENDERED,
  actionSubject: ANALYTICS_SUBJECT_NOT_FOUND,
  details: 'User landed on a not found page',
  type: UI_EVENT_TYPE
};
export const ModalRenderedEvent = {
  action: ANALYTICS_ACTION_RENDERED,
  actionSubject: ANALYTICS_SUBJECT_MODAL,
  details: 'User opened a Modal',
  type: UI_EVENT_TYPE
};
export const CheckboxClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_CHECKBOX,
  details: 'User clicked a checkbox',
  type: UI_EVENT_TYPE
};
export const BannerViewedEvent = {
  action: ANALYTICS_ACTION_VIEWED,
  actionSubject: ANALYTICS_SUBJECT_BANNER,
  details: 'User viewed a banner',
  type: UI_EVENT_TYPE
};
export const TooltipViewedEvent = {
  action: ANALYTICS_ACTION_VIEWED,
  actionSubject: ANALYTICS_SUBJECT_TOOLTIP,
  details: 'User viewed a Tooltip',
  type: UI_EVENT_TYPE
};